import { FieldError, Input, Label, NumberField, TextField } from "react-aria-components";

interface ITextField {
    label?: string
    visibleLabel: boolean
    icon?: any
    onChangeText: Function,
    required?: boolean,
    className?: string,
    disabled: boolean,
    max?: number
    min?: number
    value: string | undefined,
    validateRule?: Function,
    validationError?: string,
    step?: number
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    autocomplete?: string
    name?: string
    inputType?: string
}

export default function AdobeNumberField({ label, visibleLabel, icon, onChangeText, required, className, max, min, disabled = false, value, validateRule, validationError, step, onKeyDown, autocomplete, name, inputType }: ITextField) {

    function validate(val: string) {
        if (!required && (!val || val === '')) return null;
        if (validateRule) {
            return validateRule(val) ? null : validationError;
        }
    }

    function handleChange(val: string) {
        onChangeText(val);
    }

    function handleWheel(e: React.WheelEvent<HTMLInputElement>) {
        e.currentTarget.blur();
    }

    return (
        <TextField type="number" value={value} className={"search-field"} aria-label={label} onChange={handleChange} isDisabled={disabled} validate={validate}>
            {visibleLabel && <Label className="small display--block margin__bottom--xxs">{label}{required ? " (required)" : ""}</Label>}
            <Input onKeyDown={onKeyDown} onWheel={handleWheel} type="number" />
            <img src={icon} />
            <FieldError />
        </TextField>
    )
}